import React  from 'react';
import { ReferenceArrayField, SingleFieldList, ChipField, TextField, CloneButton } from "react-admin";
import { ListGuesser } from "@api-platform/admin";

const CloneElement = ({ record }) => {
  const omitId = ({ id, originId, uuid, ...rest }) => rest;
  delete record["@type"];
  delete record["@id"];

  return (<CloneButton to={{
          pathname: `step_format_attributes/create`,
          state: { record: omitId(record) }
        }}/>);
};

const StepFormatAttributeList = (props) => (
    <ListGuesser {...props}>
      <TextField source="name" />
      <TextField source="title" />
      <ReferenceArrayField
        label="Format values"
        reference="step_format_values"
        source="stepFormatValues"
      >
        <SingleFieldList>
            <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <CloneElement />
    </ListGuesser>
);

export default StepFormatAttributeList;